import { useDropdownInputTemplate } from "./template-logic";
import Select, { StylesConfig } from 'react-select';

const colors = require("@theme/colors") as Record<string, any>;

export type DropdownInputTemplateProps = {
  type: string;
  placeholder: any;
  value: string | number | null | undefined;
  onChange: (e: any) => void;
  name: string;
  errorMessage: string | undefined;
  options: any[];
};

export const DropdownInputTemplate = ({
  type,
  placeholder,
  value,
  onChange,
  name,
  errorMessage,
  options
}: DropdownInputTemplateProps): JSX.Element => {
  const { isActive, toggleFocus, toggleBlur, inputRef } = useDropdownInputTemplate(
    value,
  );
  const selectedOption =
    options.find((option) => option.value === value) ??
    (placeholder && typeof placeholder === "object" ? placeholder : null);
  
  const colourStyles: StylesConfig<any> = {
    control: (styles, state) => ({
      ...styles,
      backgroundColor: "#fff",
      borderColor: state.isFocused ? colors.primary.medium : colors.neutral.light,
      boxShadow: state.isFocused ? `0 0 0 1px ${colors.primary.mediumish}` : "none",
      ":hover": {
        ...styles[":hover"],
        borderColor: state.isFocused ? colors.primary.medium : colors.primary.mediumish,
      },
    }), // white with orange focus border/ring
    option: (styles, { data, isDisabled, isFocused, isSelected }) => {
      return {
        ...styles,
        backgroundColor: isSelected
          ? colors.primary.light
          : isFocused
          ? colors.primary.medium
          : "#fff", // white
        color: isSelected ? "#201A15" : isFocused ? colors.white : "#201A15",
        cursor: 'default',
        ':active': {
          ...styles[':active'],
          backgroundColor: isSelected
              ? colors.primary.light
              : colors.primary.medium,
          color: colors.white,
        },
      };
    },
    menu: (styles) => ({
      ...styles,
      zIndex: 5,
    }),
    menuPortal: (styles) => ({
      ...styles,
      zIndex: 20,
    }),
    menuList: (styles) => ({
      ...styles,
      maxHeight: 220,
      overflowY: "auto",
    }),
    input: (styles) => ({ ...styles }),
    placeholder: (styles) => ({ ...styles }),
    singleValue: (styles, { data }) => ({ ...styles }),
  };

  return (
    <div>
      <Select
        value={selectedOption}
        placeholder={placeholder?.label ?? placeholder}
        onChange={onChange}
        options={options}
        menuPortalTarget={typeof document !== "undefined" ? document.body : undefined}
        menuPlacement="auto"
        menuPosition="fixed"
        styles={colourStyles}
      />
      {errorMessage ? (
        <div className="text-left text-xs text-orange-600 ml-2 mt-1">
          {errorMessage}
        </div>
      ) : null}
    </div>
  );
};
